import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    Type
} from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { MatCheckbox, MatCheckboxModule } from "@angular/material/checkbox";
import { ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';
import { CheckboxComponent } from './checkbox.component';


interface DocReviewCheckboxProps extends FormlyFieldProps {
    documentNames?: string[];
    status?: string;
}

export interface FormlyDocReviewCheckboxConfig extends FormlyFieldConfig<DocReviewCheckboxProps> {
    type: 'checkbox' | Type<CheckboxComponent>
}

@Component({
    selector: 'doc-review-check',
    styleUrls: ['./document-review-checkbox-component.scss'],
    template: `
        <mat-checkbox
          [formControl]="control"
          [formlyAttributes]="field"
          class="form-checkbox"
          >
          <span class="checkboxText">I have looked at all documents needed to pass this form including those not processed by AI</span>
          @if (props.required) {
            <span
            class="mat-form-field-required-marker requiredStyle">*</span>
          }
        </mat-checkbox>
        @if (documentNames?.length) {
          <ul
            >
            @for (document of documentNames; track document) {
              <li>{{ document }}</li>
            }
          </ul>
        }
        `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCheckboxModule, FormlyModule, ReactiveFormsModule]
})

export class DocReviewCheckboxComponent 
    extends FieldType<FieldTypeConfig<DocReviewCheckboxProps>> 
    implements OnInit {
    control: UntypedFormControl;
    
    override defaultOptions = {
        defaultValue: false,
        props: {
            documentNames: [] as string[],
        },
        validators: {
            validation: [Validators.requiredTrue]
        },
        validation: {
            messages: {
                required: `Please acknowledge you have reviewed all ${this.props.status} documents before submitting`
            }
        }
    }

    ngOnInit() {
        this.control = this?.formControl as UntypedFormControl;
    }

    get documentNames(): string[] {
        const names = this.props?.documentNames as string[] | undefined;
        return Array.isArray(names) ? names: [];
    }
}